module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0029.jpg?v=e8e87309";